import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    
    constructor(
        private authService: AuthService,
        private toastr: ToastrService
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Get user from localStorage (consistent with AuthService)
        const user = this.authService.getCurrentUser();
        
        if (user && user.token) {
            const re = 's3.us-east-1.amazonaws.com'; // if request is trying to upload to s3 do not intercept header
            const re2 = 's3.amazonaws.com'; // if request is trying to upload to s3 do not intercept header
            
            // Exclude interceptor for S3 uploads and login requests
            if (request.url.search(re) === -1 && request.url.search(re2) === -1) {
                request = request.clone({
                    setHeaders: {
                        Authorization: 'Bearer ' + user.token
                    }
                });
            }
        }

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if (error.status === 401) {
                    console.log("JWT Interceptor: 401 error detected");
                    
                    // Only show toastr and logout if not already logging out
                    // This prevents multiple toastr messages when multiple requests fail simultaneously
                    if (!this.authService.isLoggingOutInProgress()) {
                        console.log("JWT Interceptor: Initiating logout");
                        // Show toastr first, then logout (which sets the flag and navigates)
                        this.toastr.error('Your session has expired. Please login again.', 'Session Expired');
                        // logout() will set the flag atomically and navigate
                        this.authService.logout();
                    } else {
                        console.log("JWT Interceptor: Logout already in progress, skipping duplicate logout");
                    }
                }
                return throwError(() => error);
            })
        );
    }
}
